module.exports = __webpack_public_path__ + "img/thumbnail-marsh.04cbc0fe.jpg";